
import { supabase } from '@/lib/supabase/client';

/**
 * Déclenche la fonction edge pour synchroniser les vidéos YouTube d'un profil
 * @param profileId ID du profil social YouTube
 * @returns Un objet indiquant le succès ou l'échec de l'opération
 */
export const syncYouTubeVideos = async (profileId: string): Promise<{success: boolean, message: string}> => {
  try {
    console.log(`Démarrage de la synchronisation des vidéos pour le profil ${profileId}`);
    
    // Appel de la fonction edge Supabase pour synchroniser les vidéos
    const { data, error } = await supabase.functions.invoke('fetch_youtube_videos', {
      body: { profileId },
    });
    
    if (error) {
      console.error('Erreur lors de la synchronisation des vidéos YouTube:', error);
      return { 
        success: false, 
        message: `Erreur lors de la synchronisation: ${error.message || 'Erreur inconnue'}` 
      };
    }
    
    console.log('Résultat de la synchronisation des vidéos:', data);
    return { 
      success: true, 
      message: data.message || 'Vidéos synchronisées avec succès' 
    };
  } catch (error) {
    console.error('Exception lors de la synchronisation des vidéos YouTube:', error);
    return { 
      success: false, 
      message: error instanceof Error ? error.message : 'Erreur inconnue lors de la synchronisation'
    };
  }
};
